import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  // When provided, overrides the count-based color so every cluster renders in
  // a single color (e.g. SWPA brand cyan).
  color: PropTypes.string,
}

const defaultProps = {
  color: null,
}

// Default count-based tier palette shared by all communities except SWPA
// (which renders every cluster in a single brand color via the `color` prop).
const CLUSTER_COLORS = {
  low: '#8DD3C7',
  mid: '#5CB8B2',
  high: '#0F5D58',
}

// Size and color scale with the number of represented locations, mirroring the
// proportional clustering pattern (small/light-mint → medium/mint → large/teal).
function clusterColor(count) {
  if (count >= 50) return CLUSTER_COLORS.high
  if (count >= 10) return CLUSTER_COLORS.mid
  return CLUSTER_COLORS.low
}

function clusterSize(count) {
  return 30 + Math.min(count, 100) * 0.3
}

function ClusterMarker({ count, onClick, color }) {
  const size = clusterSize(count)
  return (
    <button
      type="button"
      className="map-cluster-marker"
      onClick={onClick}
      aria-label={`${count} locations. Zoom in to expand.`}
      data-cy="map-cluster-marker"
      style={{
        width: size,
        height: size,
        background: color || clusterColor(count),
        color: '#fff',
        borderRadius: '50%',
        border: '2px solid rgba(255, 255, 255, 0.85)',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: Math.round(size / 2.6),
        lineHeight: 1,
        cursor: 'pointer',
        transform: 'translate(-50%, -50%)',
      }}
    >
      {count}
    </button>
  )
}

ClusterMarker.propTypes = propTypes
ClusterMarker.defaultProps = defaultProps

export default ClusterMarker
